<template>
  <el-container class="chat-page">
    <resizable-aside :default-width="260" :min-width="200" :max-width="500" storage-key="chat-aside-width">
      <div class="header" :class="configStore.electronMode ? 'header-menu-wrap' : ''">
        <div class="search-text-wrap" @click="goToSearch">
          <i class="el-icon-search el-input__icon"> </i>
          <span class="search-placeholder">搜索</span>
        </div>
      </div>
      <div class="chat-loading" v-if="loading" v-loading="true" element-loading-text="消息接收中..."
        element-loading-spinner="el-icon-loading" element-loading-background="#F9F9F9" element-loading-size="24">
      </div>
      <el-scrollbar class="chat-items" v-else>
        <div v-for="(chat, index) in chatStore.chats" :key="index">
          <chat-item v-show="!chat.delete && chat.showName" :chat="chat"
            :index="index" @click.native="onActiveItem(chat)" @delete="onDelItem(chat)" @info="onShowInfo(chat)"
            @dnd="onDnd(chat)" @top="onTop(chat)" :active="chat === chatStore.activeChat"></chat-item>
        </div>
      </el-scrollbar>
    </resizable-aside>
    <el-container class="chat-box">
      <chat-box v-if="activeChat && activeChat.type != 'SYSTEM'" :chat="activeChat" :message-id="pendingMessageId"></chat-box>
      <chat-system-box v-if="activeChat && activeChat.type == 'SYSTEM'" :chat="activeChat"></chat-system-box>
    </el-container>
  </el-container>
</template>

<script>
import ChatItem from "../../components/chat/ChatItem.vue";
import ChatBox from "../../components/chat/ChatBox.vue";
import ChatSystemBox from "../../components/chat/ChatSystemBox.vue";
import ResizableAside from "../../components/common/ResizableAside.vue";
export default {
  name: "chat",
  components: {
    ChatItem,
    ChatBox,
    ChatSystemBox,
    ResizableAside
  },
  data() {
    return {
      messageContent: "",
      group: {},
      groupMembers: [],
      pendingMessageId: null
    }
  },
  watch: {
    "$route.query": {
      handler(query) {
        this.handleRouteQuery(query);
      }
    }
  },
  mounted() {
    this.handleRouteQuery(this.$route.query);
  },
  methods: {
    handleRouteQuery(query) {
      // 根据路由参数打开对应聊天
      if (!query) return;
      if (query.friendId) {
        this.openPrivateChat(query.friendId, query.messageId);
      } else if (query.groupId) {
        this.openGroupChat(query.groupId, query.messageId);
      } else if (query.messageId) {
        // 只有messageId
        this.pendingMessageId = query.messageId;
      }
    },
    openPrivateChat(friendId, messageId) {
      const friend = this.friendStore.findFriend(parseInt(friendId));
      const chatInfo = {
        type: 'PRIVATE',
        targetId: parseInt(friendId),
        showName: friend ? friend.showNickName : "",
        headImage: friend ? friend.headImage : "",
        companyName: friend ? friend.companyName : "",
        isDnd: friend ? friend.isDnd : false,
        isTop: friend ? friend.isTop : false
      };
      this.chatStore.openChat(chatInfo);
      const chat = this.chatStore.findChat(chatInfo);
      if (chat) {
        this.chatStore.setActiveChat(chat);
      } else {
        // 如果chat还没加载好，等待一下再试
        setTimeout(() => {
          const c = this.chatStore.findChat(chatInfo);
          if (c) {
            this.chatStore.setActiveChat(c);
          }
        }, 200);
      }
      this.pendingMessageId = messageId ? parseInt(messageId) : null;
    },
    openGroupChat(groupId, messageId) {
      const group = this.groupStore.findGroup(parseInt(groupId));
      const chatInfo = {
        type: 'GROUP',
        targetId: parseInt(groupId),
        showName: group ? group.showGroupName : "",
        headImage: group ? group.headImageThumb : "",
        isDnd: group ? group.isDnd : false,
        isTop: group ? group.isTop : false
      };
      this.chatStore.openChat(chatInfo);
      const chat = this.chatStore.findChat(chatInfo);
      if (chat) {
        this.chatStore.setActiveChat(chat);
      } else {
        setTimeout(() => {
          const c = this.chatStore.findChat(chatInfo);
          if (c) {
            this.chatStore.setActiveChat(c);
          }
        }, 200);
      }
      this.pendingMessageId = messageId ? parseInt(messageId) : null;
    },
    goToSearch() {
      this.$router.push("/home/search");
    },
    onActiveItem(chat) {
      this.chatStore.setActiveChat(chat);
    },
    onDelItem(chat) {
      this.chatStore.removeChat(chat);
    },
    onShowInfo(chat) {
      if (chat.type == 'PRIVATE') {
        this.$router.push("/home/friend?id=" + chat.targetId);
      } else if (chat.type == 'GROUP') {
        if (!this.groupStore.isGroup(chat.targetId)) {
          this.$message.error("您已不在群聊中，无法查看群资料")
          return;
        }
        this.$router.push("/home/group?id=" + chat.targetId);
      }
    },
    onDnd(chat) {
      if (chat.type == 'PRIVATE') {
        this.setFriendDnd(chat, chat.targetId, !chat.isDnd)
      } else {
        this.setGroupDnd(chat, chat.targetId, !chat.isDnd)
      }
    },
    setFriendDnd(chat, friendId, isDnd) {
      let formData = {
        friendId: friendId,
        isDnd: isDnd
      }
      this.$http({
        url: '/friend/dnd',
        method: 'put',
        data: formData
      }).then(() => {
        this.friendStore.setDnd(friendId, isDnd)
        this.chatStore.setDnd(chat, isDnd)
      })
    },
    setGroupDnd(chat, groupId, isDnd) {
      let formData = {
        groupId: groupId,
        isDnd: isDnd
      }
      this.$http({
        url: '/group/dnd',
        method: 'put',
        data: formData
      }).then(() => {
        this.groupStore.setDnd(groupId, isDnd)
        this.chatStore.setDnd(chat, isDnd)
      })
    },
    onTop(chat) {
      if (chat.type == 'PRIVATE') {
        this.setFriendTop(chat, chat.targetId, !chat.isTop)
      } else {
        this.setGroupTop(chat, chat.targetId, !chat.isTop)
      }
    },
    setFriendTop(chat, friendId, isTop) {
      let formData = {
        friendId: friendId,
        isTop: isTop
      }
      this.$http({
        url: '/friend/top',
        method: 'put',
        data: formData
      }).then(() => {
        this.friendStore.setTop(friendId, isTop)
        this.chatStore.setTop(chat, isTop)
      })
    },
    setGroupTop(chat, groupId, isTop) {
      let formData = {
        groupId: groupId,
        isTop: isTop
      }
      this.$http({
        url: '/group/top',
        method: 'put',
        data: formData
      }).then(() => {
        this.groupStore.setTop(groupId, isTop)
        this.chatStore.setTop(chat, isTop)
      })
    }
  },
  computed: {
    activeChat() {
      return this.chatStore.activeChat;
    },
    loading() {
      return this.chatStore.loading
    }
  }
}
</script>

<style lang="scss">
.chat-page {
  .header {
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 12px;

    .search-text-wrap {
      flex: 1;
      height: 32px;
      display: flex;
      align-items: center;
      padding: 0 12px;
      background-color: #f5f5f5;
      border-radius: 4px;
      cursor: pointer;

      .el-input__icon {
        color: #999;
        margin-right: 4px;
      }

      .search-placeholder {
        color: #999;
        font-size: 13px;
      }

      &:hover {
        background-color: #eee;
      }
    }
  }

  .chat-loading {
    height: 50px;
    background-color: #eee;

    .el-icon-loading {
      font-size: 24px;
      color: var(--im-text-color-light);
    }

    .el-loading-text {
      color: var(--im-text-color-light);
    }

    .chat-loading-box {
      height: 100%;
    }
  }

  .chat-items {
    flex: 1;
  }
}
</style>
